import React, {
    useEffect,
    useState,
    useRef,
    Fragment,
} from 'react';
import PaymentMethodSelector from '../../shared/PaymentMethodSelector';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Tabs, Tab, Button, CircularProgress, FormHelperText, OutlinedInput } from '@mui/material';
import { getData, postData } from '../../services/fetch-service';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import PayseraPayment from '../PayseraPayment';
import dayjs from 'dayjs';
import ReCAPTCHA from 'react-google-recaptcha';
import { LoadingOverlay, Loader, Text, Skeleton } from '@mantine/core';
import { setEsimPackageSelected, setEsimRefillSelected, setPaymentResponse } from '../store/dataslice';
import Swal from 'sweetalert2';
import { FaEuroSign } from 'react-icons/fa';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import InputMask from 'react-input-mask';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

// const BootstrapDialog = styled(Dialog)(({ theme }) => ({
//     '& .MuiDialogContent-root': {
//         padding: theme.spacing(2),
//     },
//     '& .MuiDialogActions-root': {
//         padding: theme.spacing(1),
//     },
// }));

const Vala_PaymentFields = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);
    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);

    const valaPackages = [
        { price: 1, data: "1€" },
        { price: 2, data: "2€" },
        { price: 3, data: "3€" },
        { price: 5, data: "5€" },
        { price: 10, data: "10€" },
        { price: 20, data: "20€" }
    ];

    const [valaInternetList, setValaInternetList] = useState([]);
    const [valaPakoList, setValaPakoList] = useState([]);

    const [selectedValaPackage, setSelectValaPackage] = useState(null);
    const [selectedValaInternetPackage, setSelectValaInternetPackage] = useState(null);
    const [selectedValaPako, setSelectedValaPako] = useState(null);

    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);
    const [updateLoader, setUpdateLoader] = useState(false);
    const [Loan, setLoan] = useState(false);
    const [shumaValue, setShumaValue] = useState(null);
    const [tabValue, setTabValue] = useState(0);
    const [DataNumriSerik, setNumriSerik] = useState(null);
    const [paymentMethodCode, setPaymentMethodCode] = useState("wallet");
    const [acceptPay, setAccpetPay] = useState(false);

    const handleBack = () => {
        navigate('/');
        formik.resetForm();
        dispatch(setEsimPackageSelected(null));
        dispatch(setEsimRefillSelected(null));
    }

    const handlePaymentMethodCode = (event) => {
        setPaymentMethodCode(event.target.value);
    };

    const clickPaymentMethodCode = (value) => {
        setPaymentMethodCode(value);
    };

    useEffect(() => {
        if (tabValue === 1 && valaInternetList.length === 0) {
            getValaInternetList();
        } else if (tabValue === 2 && valaPakoList.length === 0) {
            getValaPakoList();
        }
    }, [tabValue]);

    //  *** add vlera per institucionin dhe llojin e pageses *** END
    const vala_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
        paguesiNumriTelefonit: Yup.string().required('Numri Telefonit është obligative!'),
    });

    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');

    const formik = useFormik({
        initialValues: {
            Email: '',
            provizioni: 0,
            strProvizioni: '0',
            llojiPagesesID: '',
            numriIdentifikues: '',
            institucioniId: '',
            numriSerik: `${DataNumriSerik}`,
            strDataPageses: `${strDataPageses}`,
            llojiKlientit: 'Fizik',
            pershkrimi: tabValue === 0 ?
                `Mbushje ${selectedValaPackage ? selectedValaPackage.data : ''}` :
                tabValue === 1 ?
                    `Internet ${selectedValaInternetPackage ? selectedValaInternetPackage.pershkrimi : ''}` :
                    tabValue === 2 ?
                        `Pako ${selectedValaPako ? selectedValaPako.name : ''}` :
                        '',
            strVlera: '',
            strVleraTotale: '0',
            paymentMethod: 3,
            paguesiNumriTelefonit: '',
            sherbimiTipiID: 7,
            // shpenzimet: 0,
            unirefOK: false,
            PaymentMethodCode: paymentMethodCode
        },
        validationSchema: vala_validationSchema,
        onSubmit: (values) => {
            const newValues = {
                ...values,
                numriSerik: `${DataNumriSerik}`,
                pershkrimi: tabValue === 0 ?
                    `Mbushje ${selectedValaPackage ? selectedValaPackage.data : ''}` :
                    tabValue === 1 ?
                        `Internet ${selectedValaInternetPackage ? selectedValaInternetPackage.pershkrimi : ''}` :
                        tabValue === 2 ?
                            `Pako ${selectedValaPako ? selectedValaPako.name : ''}` :
                            ''
            }
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(newValues);
        },
    });

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                emri: '//',
                mbiemri: '//',
                shuma: shumaValue,
                provizioni: provizioni && provizioni.provizioni,
                viti: `${new Date().getFullYear()}`,
                numriIdentifikues: data.numriIdentifikues !== '' ? `${data.numriIdentifikues}` : '',
                strProvizioni: `${provizioni && provizioni.provizioni}`,
                llojiPagesesID: tabValue === 0 ? 1164 : tabValue === 1 ? 1165 : tabValue === 2 ? 1168 : null,
                institucioniId: 186,
                numriSerik: data.numriSerik,
                // numriSerik:
                //     (EsimPackageSelected && `${EsimPackageSelected.id}`) ||
                //     (EsimRefillSelected && `${EsimRefillSelected.id}`),
                numriUnikPageses: null,
                strDataPageses: `${strDataPageses}`,
                strVlera: `${provizioni && provizioni.strShuma}`,
                strVleraTotale: `${provizioni && provizioni.strtotal_pagesa}`,
                token: token,
                PayWithLoan: Loan ? true : false,
                PaymentMethodCode: paymentMethodCode,
            }
            if (provizioni) {
                const response = await postData('Pagesat/PagesaPerSherbime', newData);
                if (response && response.status === 200) {
                    // if (!Loan && paymentMethodCode !== 'visa') {
                    //     dispatch(setPaymentResponse(response.data.respond));
                    //     setPagesaLoading(false);
                    // } else {
                    //     setLoanLoading(false);
                    //     const paymentWindow = window.open('', '_self');
                    //     paymentWindow.location.href = `${response.data.link}`;
                    // }
                    setLoanLoading(false);
                    setPagesaLoading(false);
                    setUpdateLoader(false);
                    const paymentWindow = window.open('', '_self');
                    paymentWindow.location.href = `${response.data.link}`;
                }
            }
        } catch (error) {
            setPagesaLoading(false);
            setLoanLoading(false);
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    const handlePayProcess = () => {
        if (paymentMethodCode === "PaySeraKredi") {
            handlePayWithLoan();
        } else {
            handlePay();
        }
    }

    const handlePay = async () => {
        formik.validateForm().then(async (errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                // await getProvizioni();
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    };

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }
    // provisioni
    const [finalPay, setFinalPay] = useState(true);
    const [provizioni, setProvizioni] = useState(null);
    const [shumaKey, setShumaKey] = useState(0);

    const getProvizioni = async (data) => {
        try {
            setAccpetPay(true);
            const response = await getData(`Pagesat/GetProvision?LlojiPagesesID=${tabValue === 0 ? 1164 : tabValue === 1 ? 1165 : tabValue === 2 ? 1168 : null}&Amount=${shumaValue}`, data);
            if (response && response.data && response.data.success === true) {
                setProvizioni(response.data);
                setAccpetPay(false);
                setFinalPay(false);
            } else if (response && response.data && response.data.success === false) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Informim',
                    text: `${response.data.responseText}`
                });
                formik.setFieldValue('shuma', null);
                setShumaValue(null);
                setProvizioni(null);
                setShumaKey(prev => prev + 1);
            }
        } catch (error) {
            formik.setFieldValue('shuma', null);
            setShumaValue(null);
            setProvizioni(null);
            setShumaKey(prev => prev + 1);

        }
    }

    const getValaInternetList = async () => {
        try {
            const response = await getData('VIAeSIM/ValaInternetList');
            if (response && response.data) {
                setValaInternetList(response.data)
            }
        } catch (error) {
            setValaInternetList([]);

        }
    }

    const getValaPakoList = async () => {
        try {
            const response = await getData('VIAeSIM/ValaPakoList');
            if (response && response.data) {
                setValaPakoList(response.data)
            }
        } catch (error) {
            setValaPakoList([]);
        }
    }

    useEffect(() => {
        if (selectedValaPackage !== null) {
            setShumaValue(selectedValaPackage.price);
            setNumriSerik(selectedValaPackage.price)
        }
    }, [selectedValaPackage]);

    useEffect(() => {
        if (selectedValaInternetPackage !== null) {
            setShumaValue(selectedValaInternetPackage.price);
            setNumriSerik(selectedValaInternetPackage.price)
        }
    }, [selectedValaInternetPackage]);

    useEffect(() => {
        if (selectedValaPako !== null) {
            setShumaValue(selectedValaPako.price);
            setNumriSerik(selectedValaPako.price)
        }
    }, [selectedValaPako]);

    useEffect(() => {
        if (shumaValue !== null) {
            getProvizioni();
        }
    }, [shumaValue]);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
        formik.resetForm();
        setFinalPay(true);
        setShumaKey(prev => prev + 1);
        setSelectValaPackage(null);
        setSelectValaInternetPackage(null);
        setProvizioni(null);
        setShumaValue(null);
        setSelectedValaPako(null);
        setPaymentMethodCode("wallet");
    };

    const handleValaBoxClick = (data) => {
        setSelectValaPackage(data);
        setPaymentMethodCode("wallet");
    };

    const handleValaInternetBoxClick = (data) => {
        setSelectValaInternetPackage(data);
        setPaymentMethodCode("wallet");
    };

    const handleValaPakoboxClick = (data) => {
        setSelectedValaPako(data);
        setPaymentMethodCode("wallet");
    };

    return (
        <div className="paysera-home paysera-feilds">
            <div className="home-header">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
                <span className='home-description body-font'>Platforma jonë ju ofron një mënyrë të shpejtë, të sigurt dhe të thjeshtë për të kryer pagesat direkt nga telefoni ose kompjuteri juaj.</span>
            </div>
            <div className="paysera-form-body other-feilds">
                <div className="form-box">
                    <Divider className='subheading-font esim-divider' textAlign="center">
                        <Tabs className='esim-tabs' value={tabValue} onChange={handleChange} centered>
                            <Tab label="Mbushje" />
                            <Tab label="Internet" />
                            <Tab label="Pako" />
                        </Tabs>
                    </Divider>
                    <div className="form-body">
                        {tabValue === 0 && valaPackages ? (
                            <div className="paysera-vala-form vala-form">
                                <div className={`vala-grid ${acceptPay ? 'loading-vala-grid' : ''}`}>
                                    {valaPackages.map((item, index) => (
                                        <div
                                            key={index}
                                            onClick={() => {
                                                if (!acceptPay) handleValaBoxClick(item);
                                            }}
                                            className={`${selectedValaPackage?.price === item.price ? 'selected-vala-card' : 'vala-card'} ${acceptPay ? 'loading-parking-card' : ''}`}
                                        >

                                            Mbushje <span className='vala-price'>{item.data}</span>
                                            {
                                                selectedValaPackage?.price === item.price ? (
                                                    <span className='checked'>{!acceptPay ? <IoMdCheckmarkCircle /> : <CircularProgress size={14} color="inherit" />}</span>
                                                ) :
                                                    ('')
                                            }

                                        </div>
                                    ))}
                                </div>

                                <div className="paysera-form vala-details-form">

                                    <div className="paysera-inputLabel">
                                        <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Shëno email-in tuaj"
                                                name='Email'
                                                type="email"
                                                aria-describedby="outlined-input-helper-text"
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                value={formik.values.Email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.Email && formik.errors.Email}
                                            />
                                            {
                                                formik.touched.Email && formik.errors.Email && (
                                                    <FormHelperText>{formik.errors.Email}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="paysera-inputLabel">
                                        <label className={formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit ? 'label-top' : ''} htmlFor="Numri Serik">Numri Telefonit <span className="required">*</span></label>
                                        <div className="input">
                                            <InputMask
                                                mask="049 999 999"
                                                value={formik.values.paguesiNumriTelefonit}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                name="paguesiNumriTelefonit"
                                            >
                                                {(inputProps) => (
                                                    <OutlinedInput
                                                        {...inputProps}
                                                        size="small"
                                                        id="outlined-adornment-input"
                                                        placeholder="04X XXX XXX"
                                                        aria-describedby="outlined-input-helper-text"
                                                        error={formik.touched.paguesiNumriTelefonit && Boolean(formik.errors.paguesiNumriTelefonit)}
                                                    />
                                                )}
                                            </InputMask>
                                            {/* <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Shëno numrin e telefonit"
                                                name='paguesiNumriTelefonit'
                                                type=""
                                                aria-describedby="outlined-input-helper-text"
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                value={formik.values.paguesiNumriTelefonit}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit}
                                            /> */}
                                            {
                                                formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit && (
                                                    <FormHelperText>{formik.errors.paguesiNumriTelefonit}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="paysera-inputLabel">
                                        <label
                                            className={formik.touched.shuma && formik.errors.shuma ? 'label-top' : ''}
                                            htmlFor="Shuma e pagesës"
                                        >
                                            Shuma e pagesës <span className="required">*</span>
                                        </label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="shuma-input-nr"
                                                type='number'
                                                disabled
                                                name='shuma'
                                                key={shumaKey}
                                                placeholder="Shuma për pagesë"
                                                className='number-input'
                                                aria-describedby="outlined-input-helper-text"
                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                inputProps={{
                                                    'aria-label': 'input',
                                                    // inputMode: 'numeric'
                                                }}
                                                value={shumaValue}
                                                endAdornment={<FaEuroSign />}
                                                error={formik.touched.shuma && formik.errors.shuma}
                                            />
                                            {
                                                formik.touched.shuma && formik.errors.shuma && (
                                                    <FormHelperText>{formik.errors.shuma}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Provizioni"> Provizioni</label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Provizioni"
                                                key={shumaKey}
                                                readOnly
                                                aria-describedby="outlined-input-helper-text"
                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                name='Provizioni'
                                                value={provizioni && provizioni.provizioni}
                                            />
                                        </div>
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Provizioni">Shuma Totale</label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Provizioni"
                                                endAdornment={<FaEuroSign />}
                                                key={shumaKey}
                                                readOnly
                                                aria-describedby="outlined-input-helper-text"
                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                name='strVleraTotale'
                                                value={provizioni && provizioni.strtotal_pagesa}
                                            />
                                        </div>
                                    </div>
                                    <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                                    <div className="p-buttons">
                                        <div className="payForm-btn">
                                            <Button type="button" variant="outlined" onClick={handleBack}>
                                                Kthehu
                                            </Button>
                                            {/* <Button
                                                id="payNow"
                                                type="button"
                                                variant="contained"
                                                onClick={handlePayWithLoan}
                                                // disabled
                                                disabled={loanLoading}
                                                startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                            >
                                                {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                            </Button> */}
                                            <Button
                                                id="payNow"
                                                type="button"
                                                variant="contained"
                                                onClick={handlePayProcess}
                                                disabled={finalPay || (pagesaLoading || acceptPay)}
                                                startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                            >
                                                {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                    </div>
                                </div> */}
                            </div>
                        ) : (tabValue === 1) ? (
                            <div className="paysera-vala-form valaInternet-form">
                                <Fragment>  {
                                    valaInternetList.length === 0 ? (
                                        <div className="vala-grid vala-internet-grid">
                                            {Array.from({ length: 6 }).map((_, index) => (
                                                <Skeleton key={index} height={138} className="skeleton-box" />
                                            ))}
                                        </div>
                                    )
                                        : (
                                            <div className={`vala-grid vala-internet-grid ${acceptPay ? 'loading-vala-grid' : ''}`}>
                                                {valaInternetList.map((item, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => {
                                                            if (!acceptPay) handleValaInternetBoxClick(item);
                                                        }}
                                                        className={`${selectedValaInternetPackage?.price === item.price ? 'selected-valaInternet-card' : 'valaInternet-card'} ${acceptPay ? 'loading-valaInternet-card' : ''}`}
                                                    >
                                                        <div className="internet-details">
                                                            Internet <span className='vala-price'>{item.name}</span>
                                                        </div>
                                                        <div className="internet-desc">
                                                            {/* <Text>{item.price}</Text> */}
                                                            <Text>Çmimi {item.price}€</Text>
                                                            <Text c="dimmed">{item.validiteti}</Text>
                                                        </div>
                                                        {
                                                            selectedValaInternetPackage?.price === item.price ? (
                                                                <span className='checked'>{!acceptPay ? <IoMdCheckmarkCircle /> : <CircularProgress size={14} color="inherit" />}</span>
                                                            ) :
                                                                ('')
                                                        }

                                                    </div>
                                                ))}
                                            </div>
                                        )
                                }
                                </Fragment>

                                <div className="paysera-form vala-details-form">

                                    <div className="paysera-inputLabel">
                                        <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Shëno email-in tuaj"
                                                name='Email'
                                                type="email"
                                                aria-describedby="outlined-input-helper-text"
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                value={formik.values.Email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.Email && formik.errors.Email}
                                            />
                                            {
                                                formik.touched.Email && formik.errors.Email && (
                                                    <FormHelperText>{formik.errors.Email}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="paysera-inputLabel">
                                        <label className={formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit ? 'label-top' : ''} htmlFor="Numri Serik">Numri Telefonit <span className="required">*</span></label>
                                        <div className="input">
                                            <InputMask
                                                mask="049 999 999"
                                                value={formik.values.paguesiNumriTelefonit}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                name="paguesiNumriTelefonit"
                                            >
                                                {(inputProps) => (
                                                    <OutlinedInput
                                                        {...inputProps}
                                                        size="small"
                                                        id="outlined-adornment-input"
                                                        placeholder="04X XXX XXX"
                                                        aria-describedby="outlined-input-helper-text"
                                                        error={formik.touched.paguesiNumriTelefonit && Boolean(formik.errors.paguesiNumriTelefonit)}
                                                    />
                                                )}
                                            </InputMask>
                                            {/* <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Shëno numrin e telefonit"
                                                name='paguesiNumriTelefonit'
                                                type=""
                                                aria-describedby="outlined-input-helper-text"
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                value={formik.values.paguesiNumriTelefonit}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit}
                                            /> */}
                                            {
                                                formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit && (
                                                    <FormHelperText>{formik.errors.paguesiNumriTelefonit}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="paysera-inputLabel">
                                        <label
                                            className={formik.touched.shuma && formik.errors.shuma ? 'label-top' : ''}
                                            htmlFor="Shuma e pagesës"
                                        >
                                            Shuma e pagesës <span className="required">*</span>
                                        </label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="shuma-input-nr"
                                                type='number'
                                                disabled
                                                name='shuma'
                                                key={shumaKey}
                                                placeholder="Shuma për pagesë"
                                                className='number-input'
                                                aria-describedby="outlined-input-helper-text"
                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                inputProps={{
                                                    'aria-label': 'input',
                                                    // inputMode: 'numeric'
                                                }}
                                                value={shumaValue}
                                                endAdornment={<FaEuroSign />}
                                                error={formik.touched.shuma && formik.errors.shuma}
                                            />
                                            {
                                                formik.touched.shuma && formik.errors.shuma && (
                                                    <FormHelperText>{formik.errors.shuma}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Provizioni"> Provizioni</label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Provizioni"
                                                key={shumaKey}
                                                readOnly
                                                aria-describedby="outlined-input-helper-text"
                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                name='Provizioni'
                                                value={provizioni && provizioni.provizioni}
                                            />
                                        </div>
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Provizioni">Shuma Totale</label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Provizioni"
                                                endAdornment={<FaEuroSign />}
                                                key={shumaKey}
                                                readOnly
                                                aria-describedby="outlined-input-helper-text"
                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                name='strVleraTotale'
                                                value={provizioni && provizioni.strtotal_pagesa}
                                            />
                                        </div>
                                    </div>
                                    <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                                    <div className="p-buttons">
                                        <div className="payForm-btn">
                                            <Button type="button" variant="outlined" onClick={handleBack}>
                                                Kthehu
                                            </Button>
                                            {/* <Button
                                                id="payNow"
                                                type="button"
                                                variant="contained"
                                                onClick={handlePayWithLoan}
                                                // disabled
                                                disabled={loanLoading}
                                                startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                            >
                                                {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                            </Button> */}
                                            <Button
                                                id="payNow"
                                                type="button"
                                                variant="contained"
                                                onClick={handlePayProcess}
                                                disabled={finalPay || (pagesaLoading || acceptPay)}
                                                startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                            >
                                                {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                    </div>
                                </div> */}
                            </div>
                        ) : (tabValue === 2) ? (
                            <div className="paysera-vala-form valaPako-form">
                                <Fragment>   {
                                    valaPakoList.length === 0 ? (
                                        <div className="vala-grid vala-pako-grid">
                                            {Array.from({ length: 6 }).map((_, index) => (
                                                <Skeleton key={index} height={125} className="skeleton-box" />
                                            ))}
                                        </div>
                                    )
                                        : (
                                            <div className={`vala-grid vala-pako-grid ${acceptPay ? 'loading-vala-grid' : ''}`}>
                                                {valaPakoList.map((item, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => {
                                                            if (!acceptPay) handleValaPakoboxClick(item);
                                                        }}
                                                        className={`${selectedValaPako?.price === item.price ? 'selected-valaInternet-card' : 'valaInternet-card'} vala-pako-card ${acceptPay ? 'loading-valaInternet-card' : ''}`}
                                                    >
                                                        <div className={`${item.llojiPako === "FOL" ? 'pako-FOL' : 'pako-INT'} pako-type`}>
                                                            <span className='vala-pako'>{item.name}</span>
                                                        </div>
                                                        <div className="pako-details">
                                                            <span className={`${item.llojiPako === "FOL" ? 'pako-gb-FOL' : 'pako-gb-INT'} pako-gb`}>{item.pershkrimi ? item.pershkrimi.replace(/\binternet\b/gi, '').replace(/\s{2,}/g, ' ').trim() : ''}</span>
                                                            <span>{item.pershkrimi ? (/\binternet\b/i.test(item.pershkrimi) ? 'internet' : item.pershkrimi) : ''}</span>
                                                        </div>
                                                        <div className="pako-desc">
                                                            <Text>Çmimi {item.price}€</Text>
                                                            <Text c="dimmed">{item.validiteti}</Text>
                                                        </div>
                                                        {
                                                            selectedValaPako?.price === item.price ? (
                                                                <span className='checked'>{!acceptPay ? <IoMdCheckmarkCircle /> : <CircularProgress size={14} color="inherit" />}</span>
                                                            ) :
                                                                ('')
                                                        }

                                                    </div>
                                                ))}
                                            </div>
                                        )
                                }
                                </Fragment>


                                <div className="paysera-form vala-details-form">

                                    <div className="paysera-inputLabel">
                                        <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Shëno email-in tuaj"
                                                name='Email'
                                                type="email"
                                                aria-describedby="outlined-input-helper-text"
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                value={formik.values.Email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.Email && formik.errors.Email}
                                            />
                                            {
                                                formik.touched.Email && formik.errors.Email && (
                                                    <FormHelperText>{formik.errors.Email}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="paysera-inputLabel">
                                        <label className={formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit ? 'label-top' : ''} htmlFor="Numri Serik">Numri Telefonit <span className="required">*</span></label>
                                        <div className="input">
                                            <InputMask
                                                mask="049 999 999"
                                                value={formik.values.paguesiNumriTelefonit}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                name="paguesiNumriTelefonit"
                                            >
                                                {(inputProps) => (
                                                    <OutlinedInput
                                                        {...inputProps}
                                                        size="small"
                                                        id="outlined-adornment-input"
                                                        placeholder="04X XXX XXX"
                                                        aria-describedby="outlined-input-helper-text"
                                                        error={formik.touched.paguesiNumriTelefonit && Boolean(formik.errors.paguesiNumriTelefonit)}
                                                    />
                                                )}
                                            </InputMask>
                                            {/* <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Shëno numrin e telefonit"
                                                name='paguesiNumriTelefonit'
                                                type=""
                                                aria-describedby="outlined-input-helper-text"
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                value={formik.values.paguesiNumriTelefonit}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit}
                                            /> */}
                                            {
                                                formik.touched.paguesiNumriTelefonit && formik.errors.paguesiNumriTelefonit && (
                                                    <FormHelperText>{formik.errors.paguesiNumriTelefonit}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="paysera-inputLabel">
                                        <label
                                            className={formik.touched.shuma && formik.errors.shuma ? 'label-top' : ''}
                                            htmlFor="Shuma e pagesës"
                                        >
                                            Shuma e pagesës <span className="required">*</span>
                                        </label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="shuma-input-nr"
                                                type='number'
                                                disabled
                                                name='shuma'
                                                key={shumaKey}
                                                placeholder="Shuma për pagesë"
                                                className='number-input'
                                                aria-describedby="outlined-input-helper-text"
                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                inputProps={{
                                                    'aria-label': 'input',
                                                    // inputMode: 'numeric'
                                                }}
                                                value={shumaValue}
                                                endAdornment={<FaEuroSign />}
                                                error={formik.touched.shuma && formik.errors.shuma}
                                            />
                                            {
                                                formik.touched.shuma && formik.errors.shuma && (
                                                    <FormHelperText>{formik.errors.shuma}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Provizioni"> Provizioni</label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Provizioni"
                                                key={shumaKey}
                                                readOnly
                                                aria-describedby="outlined-input-helper-text"
                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                name='Provizioni'
                                                value={provizioni && provizioni.provizioni}
                                            />
                                        </div>
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Provizioni">Shuma Totale</label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="outlined-adornment-input"
                                                placeholder="Provizioni"
                                                endAdornment={<FaEuroSign />}
                                                key={shumaKey}
                                                readOnly
                                                aria-describedby="outlined-input-helper-text"
                                                startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                                inputProps={{
                                                    'aria-label': 'input',
                                                }}
                                                name='strVleraTotale'
                                                value={provizioni && provizioni.strtotal_pagesa}
                                            />
                                        </div>
                                    </div>
                                    <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                                    <div className="p-buttons">
                                        <div className="payForm-btn">
                                            <Button type="button" variant="outlined" onClick={handleBack}>
                                                Kthehu
                                            </Button>
                                            <Button
                                                id="payNow"
                                                type="button"
                                                variant="contained"
                                                onClick={handlePayProcess}
                                                disabled={finalPay || (pagesaLoading || acceptPay)}
                                                startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                            >
                                                {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <div className="skeletonBox-detajet">
                                    <h4 className="skeleton-title-font" >Për të shfaqur detajet e pagesës kërkoni përmes UNIREF.</h4>
                                </div>
                                <div className="skeleton-btn">
                                    <Button type="button" variant="outlined" onClick={handleBack}>
                                        Kthehu
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div >
    )
}

export default Vala_PaymentFields
